import { useScopedAppFlagStore } from '@frontend/scope';
import { FeatureFlagStrategy } from '@frontend/shared';

export const useGetPreferenceBasedRequestFeatureFlagDetails = (strategy: FeatureFlagStrategy = 'ALL') => {
  const { getFeatureFlagValue, getFeatureFlagLocationMap } = useScopedAppFlagStore();
  const isPreferenceBasedRequestEnabled = getFeatureFlagValue('schedule-air-preference-requests', strategy);
  const ffLocationMap = getFeatureFlagLocationMap('schedule-air-preference-requests');
  const enabledLocationIds = Object.keys(ffLocationMap).filter((locationId) => !!ffLocationMap[locationId]);

  return {
    isPreferenceBasedRequestEnabled,
    enabledLocationIds,
  };
};
